/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useMemo, useContext } from 'react'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  getForecastDataGenon,
  saveMarginForecastGenon,
  deleteMarginForecastGenon,
  getAuthorization,
  getCredentials,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, InputNumber, message, Select, Input, Upload, Icon } from 'antd'
import * as Actions from 'core/EventActions'
import { monthsMap } from 'core/utils'
import CommonScreen from 'admin/component/CommonScreen'
import R from 'ramda'
// import { getPFuelCodeAtFuelUsageByClients } from 'marginanalysis/utils'

// import { toSelectionColProps } from '@integec/grid-tools'

import { JcTmpErrorContext, PNodeZoneContext, SpinContext } from 'context'
import moment from 'moment'
import { toSelectionColProps } from '@integec/grid-tools'
import MarginAnalysisUtilityUnitSelection from '../MarginAnalysisUtilityUnitSelection'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'

const title = 'Forecast Data'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

// eslint-disable-next-line no-unused-vars
const ForecastData = ({ targetInfo, envConfig, actionPermits, ...props }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const [editMode] = useState(true)

  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )

  const { setTmpError } = useContext(JcTmpErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)

  const ForecastHeaders = [
    strCol({
      ...unitIdHeader,
      isKey: true,
      sortOrder: 'asc',
      dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
      sortIndexGetter: ({ rowData }) =>
        emktIdUnitNameMap[rowData.unitId] ||
        emktIdUnitNameMap[rowData.unitid] ||
        rowData.unitId ||
        rowData.unitid,
    }),

    intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
    intCol({
      ident: 'month',
      display: 'Month',
      isKey: true,
      sortOrder: 'asc',
      ...toSelectionColProps(monthsMap),
    }),
    strCol({ ident: 'rollupId', display: 'Rollup Id', isFiltered: true }),
    numCol({ ident: 'poh', display: 'POH', isFiltered: true }),
    numCol({ ident: 'sh', display: 'SH', isFiltered: true }),
    // numCol({ ident: 'ph', display: 'PH', isFiltered: true }),
    numCol({ ident: 'netgen', display: 'Netgen', isFiltered: true }),
    numCol({ ident: 'actlStart', display: 'Actual Starts', isFiltered: true }),
    numCol({
      ident: 'atmptStart',
      display: 'Attempt Starts',
      isFiltered: true,
    }),

    modifierCol,
    modifiedDateCol,
  ]

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow style={{ paddingLeft: '0px' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '90px 150px 100px 150px 100px 150px 140px 150px 100px 150px',
          gridGap: '5px',
        }}
      >
        <Label>Year :</Label>
        <InputNumber
          value={insertData.year}
          onChange={year => {
            setInsertData({
              ...insertData,
              year,
            })
          }}
        />
        <Label>Month :</Label>
        <Select
          value={insertData.month}
          onChange={month => {
            setInsertData({
              ...insertData,
              month,
            })
          }}
          style={{ width: '100%' }}
        >
          {R.range(1, 13).map(i => (
            <Select.Option key={i + ''} value={i + ''}>
              {i}-{monthsMap[i + '']}
            </Select.Option>
          ))}
        </Select>
        <Label>Unit :</Label>
        <div style={{ gridColumn: 'span 3' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: unitIdEmktIdMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
          />
        </div>

        <Label>Rollup Id :</Label>
        <Input
          value={insertData.rollupId}
          onChange={e =>
            setInsertData({ ...insertData, rollupId: e.target.value })
          }
        />
        <Label>POH :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.poh}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, poh: value })}
        />

        <Label>SH :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.sh}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, sh: value })}
        />
        <Label>Netgen :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.netgen}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, netgen: value })}
        />
        <Label>Actual Starts :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.actlStart}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, actlStart: value })}
        />
        <Label>Attempt Starts :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.atmptStart}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, atmptStart: value })
          }
        />
        <div />
        <div
          style={{
            display: 'grid',
            gridColumnEnd: 'span 3',
            gridTemplateColumns: 'auto auto auto',
            justifyContent: 'space-between',
            alignContent: 'end',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CriteriaRow>
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const importEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [Actions.MARGIN_ANALYSIS_FORECAST_IMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const [year, setYear] = useState(moment().format('YYYY'))
  const [month, setMonth] = useState('ALL')

  // eslint-disable-next-line no-unused-vars
  const withCriteria = (s, p, selectedUnits, d) => {
    return {
      year,
      allormonth: month,
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  const isEditableGrid = ({ header }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '100px 120px' }}>
        <InputNumber
          value={year}
          onChange={year => {
            setYear(year)
            onChange()
          }}
        />
        <Select
          value={month}
          onChange={value => {
            setMonth(value)
            onChange()
          }}
          style={{ width: '100%' }}
        >
          <Select.Option key="ALL" value="ALL">
            ALL
          </Select.Option>
          {R.range(1, 13).map(i => (
            <Select.Option key={i + ''} value={i + ''}>
              {i}-{monthsMap[i + '']}
            </Select.Option>
          ))}
        </Select>
      </div>
    )
  }
  // eslint-disable-next-line no-unused-vars
  const modifySaveDataBeforeSave = (saveData, validateData) => {
    return saveData
  }
  const insertValidation = data => {
    if (!data.unitId) {
      message.warning('Unit is required')
      return false
    } else if (!data.year) {
      message.warning('Year is required')
      return false
    } else if (!data.month) {
      message.warning('Month is required')
      return false
    }
    return true
  }
  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  const fileProps = {
    name: 'file',
    action: `${targetInfo.baseUrl}/marginanalysisdata/import-forecast-data`,
    method: 'POST',
    headers: getAuthorization(targetInfo),
    ...getCredentials(targetInfo),
  }

  const extraCriteriaAfterButton = ({ onRetrieve }) => {
    if (!importEventActionPermission) return <div />
    return (
      <Upload
        {...fileProps}
        onChange={data => {
          setSpinning(true)
          if (data.file.status === 'done') {
            setSpinning(false)

            // setImportResponse(data.file.response)
            const errors = data.file.response
            if (errors.length > 0) setTmpError(errors)
            if (!isErrorContains(errors)) {
              message.success('File imported successfully')
              onRetrieve()
            }
          }
        }}
        multiple={false}
        showUploadList={false}
      >
        <Button style={{ marginLeft: '5px' }} loading={spinning}>
          <Icon type="upload" /> Import
        </Button>
      </Upload>
    )
  }

  return (
    <div>
      <CommonScreen
        extraCriteriaAfterButton={extraCriteriaAfterButton}
        autoFixColByKey={false}
        withUnitSelection
        extraUnitSelectionProps={extraUnitSelectionProps}
        insertValidation={insertValidation}
        modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        screenCriteria={screenCriteria}
        withoutModify={!writeEventActionPermission}
        withDelete={!writeEventActionPermission}
        allowInsert={writeEventActionPermission}
        isEditableGrid={isEditableGrid}
        withDatePickerTitle=""
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        title={title}
        header={ForecastHeaders}
        saveTask={saveMarginForecastGenon}
        retrieveTask={getForecastDataGenon}
        deleteTask={deleteMarginForecastGenon}
        // altBy={u => u.unitId}
        sortOptions={ForecastHeaders}
        initialSortOptions={ForecastHeaders}
        widthOffset={50}
        insertComp={insertEvent && insertComp}
        insertCompHeight={120}
        onInsertEvent={b => setInsertEvent(b)}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(ForecastData)
